import validateMeta from './validateMeta';
import {LIB_NAME} from './constants';

export default function validateSetInteractionIdArguments(meta, fnName, id) {
	validateMeta(meta, fnName);
	if (process.env.NODE_ENV === 'development') {
		if (typeof id !== 'string')
			console.warn(`${LIB_NAME} ${fnName}() arguments[1] interactionId must be a string.`); // eslint-disable-line no-console
	}
}
